<ng-template>
  <app-house-details-sd
    [property]="apartmentType"
    [agency]="agencyService.agency"
  >
  </app-house-details-sd>
</ng-template>

<section class="details">
  <div
    fxLayout="column"
    fxLayout.gt-md="row wrap"
    fxLayoutAlign="space-between"
    class="container"
  >
    <div
      class="house-details"
    >
      <div class="aw-item slider">
        <app-images-carousel-base
          *ngIf="apartmentType.images?.length"
          [images]="apartmentType.images"
        >
        </app-images-carousel-base>
        <a
          mat-raised-button
          color="main-darker"
          fxHide.gt-sm
          [href]="'tel:' + agencyService.agency.phone"
        >
          {{ 'buttons.call_agent' | translate }}
        </a>
      </div>

      <div class="aw-item house-description">
        <div
          fxLayout="row wrap"
          fxLayoutAlign="center center"
          fxLayoutAlign.gt-xs="space-between center"
          class="title-container"
        >
          <h2 translate>
            {{ apartmentType.title }}
          </h2>
          <label *ngIf="apartmentType.sale_price">
            {{ apartmentType.sale_price | number:'.0' }}{{ 'model.currency_id.' + apartmentType.currency_id | translate }} + TVA
          </label>
        </div>
        <p
          [innerHTML]="apartmentType.description"
          class="item-description"
        >
        </p>

        <div
          fxLayout="column"
          fxLayout.gt-sm="row"
        >
          <div fxFlex.gt-sm="70">
            <h2
              class="property-description-title"
            >
              {{ 'pages.house_details.subtitles.description' | translate }}
            </h2>
            <div
              fxLayout="row"
              class="description-list"
            >
              <table>
                <tbody>
                  <tr *ngIf="apartmentType.type_name">
                    <td>
                      {{ 'pages.house_details.property_description.type_name' | translate }}
                    </td>
                    <td>
                      {{ apartmentType.type_name }}
                    </td>
                  </tr>
                  <tr *ngIf="apartmentType.room_count">
                    <td>
                      {{ 'pages.house_details.property_description.room_count' | translate }}
                    </td>
                    <td>
                      {{ apartmentType.room_count }}
                    </td>
                  </tr>
                  <tr *ngIf="apartmentType.bathroom_count">
                    <td>
                      {{ 'pages.house_details.property_description.bathroom_count' | translate }}
                    </td>
                    <td>
                      {{ apartmentType.bathroom_count }}
                    </td>
                  </tr>
                  <tr *ngIf="apartmentType.properties_count > 0">
                    <td>
                      {{ 'pages.house_details.property_description.properties_count' | translate }}
                    </td>
                    <td>
                      {{ apartmentType.properties_count }}
                    </td>
                  </tr>
                  <tr
                    class="available"
                    *ngIf="apartmentType.available_properties_count > 0"
                  >
                    <td>
                      {{ 'pages.house_details.property_description.available_properties_count' | translate }}
                    </td>
                    <td>
                      {{ apartmentType.available_properties_count }}
                    </td>
                  </tr>
                  <tr
                    class="sold-out"
                    *ngIf="apartmentType.available_properties_count === 0"
                  >
                    <td colspan="2">
                      Sold Out
                    </td>
                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr *ngIf="apartmentType.usable_size_sqm">
                    <td>
                      {{ 'pages.house_details.property_description.usable_size_sqm' | translate }}
                    </td>
                    <td>
                      {{ apartmentType.usable_size_sqm | number:'.2' }}
                      m
                      <sup>2</sup>
                    </td>
                  </tr>
                  <tr *ngIf="apartmentType.built_size_sqm">
                    <td>
                      {{ 'pages.house_details.property_description.built_size_sqm' | translate }}
                    </td>
                    <td>
                      {{ apartmentType.built_size_sqm | number:'.2' }}
                      m
                      <sup>2</sup>
                    </td>
                  </tr>
                  <tr *ngIf="apartmentType.balcony_size_sqm">
                    <td>
                      {{ 'pages.house_details.property_description.balcony_size_sqm' | translate }}
                    </td>
                    <td>
                      {{ apartmentType.balcony_size_sqm | number:'.2' }}
                      m
                      <sup>2</sup>
                    </td>
                  </tr>
                  <tr *ngIf="apartmentType.total_size_sqm">
                    <td>
                      {{ 'pages.house_details.property_description.total_size_sqm' | translate }}
                    </td>
                    <td>
                      {{ apartmentType.total_size_sqm | number:'.2' }}
                      m
                      <sup>2</sup>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div fxFlex.gt-sm="30" *ngIf="(apartmentType.garden_size_sqm) > 0">
            <h2
              class="property-description-title"
            >
              {{ 'pages.house_details.subtitles.garden_size' | translate }}:
            </h2>

            <table>
              <tr
                *ngFor="let property of apartmentType.properties.sort(compareString)"
                [class]="property.availability"
              >
                <td>
                  {{ property.project.name }}
                </td>
                <td>
                  {{ property.garden_size_sqm }}
                  m
                  <sup>2</sup>
                </td>
                <td>
                  ({{ 'model.property.availability.' + property.availability | translate }})
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div
        class="contact-agent"
        fxLayout="column"
        fxLayoutAlign="start start"
      >
        <h2>
          Contact {{ agencyService.agency.name }}
        </h2>
        <div
          fxLayout="column"
          fxLayoutAlign="start center"
        >
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
          >
            <img
              src="/assets/icons/contact/phone_grey.svg"
              alt=""
            >
            <a
              [href]="'tel:' + agencyService.agency.phone"
              appGtagEvent
              eventCategory="contact"
              eventAction="click"
              eventLabel="phone_click"
              appFbqEvent="Lead"
              [customData]="{content_name: 'phone_click', content_category: 'click'}"
            >
              {{ agencyService.agency.phone | beautify }}
            </a>
          </div>
          <a
            fxLayout="row"
            fxLayoutAlign="center center"
            [href]="'mailto:' + agencyService.agency.email"
            appGtagEvent
            eventCategory="contact"
            eventAction="click"
            eventLabel="email_click"
            appFbqEvent="Lead"
            [customData]="{content_name: 'email_click', content_category: 'click'}"
            target="_blank"
          >
            <img
              src="/assets/icons/contact/email_grey.svg"
              alt=""
            >
            {{ agencyService.agency.email }}
          </a>
        </div>
      </div>
      <div class="aw-item gmaps">
        <h2>
          {{ 'pages.house_details.subtitles.localisation' | translate }}
        </h2>
        <app-google-map-iframe
          [latitude]="item.latitude | parseFloat"
          [longitude]="item.longitude | parseFloat"
        >
        </app-google-map-iframe>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/houses/apartment-type-details.component.html